;(function(){
  // read the selected facet labels that Shopify renders for us
  var labels = window._activeFilterMap && Array.isArray(window._activeFilterMap)
    ? window._activeFilterMap.map(f=>f.label)
    : [];
  if (!labels.length) return;
  var cache = {};

  function rewriteLinks(){
    document.querySelectorAll('a[href*="/products/"]').forEach(function(a){
      // only run once per link
      if (a.dataset.dvDone) return;
      var href = a.getAttribute('href').split('?')[0];
      var m = href.match(/\/products\/([^\/]+)/);
      if (!m) {
        a.dataset.dvDone = '1';
        return;
      }
      var handle = m[1];
      a.dataset.dvDone = '1';

      // fetch & cache the product JSON
      if (!cache[handle]) {
        cache[handle] = fetch('/products/' + handle + '.js')
          .then(r => r.ok ? r.json() : null)
          .catch(()=>null);
      }

      cache[handle].then(function(prod){
        if (!prod) return;
        var variant = prod.variants.find(function(v){
          return labels.every(lbl => v.options.includes(lbl));
        });
        if (variant) {
          var url = new URL(a.href, location.origin);
          url.search = window.location.search;
          url.searchParams.set('variant', variant.id);
          a.setAttribute('href', url.toString());
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', rewriteLinks);
  window.addEventListener('popstate', rewriteLinks);
  // if your theme re-renders the section via AJAX
  document.addEventListener('shopify:section:load', rewriteLinks);
  document.addEventListener('shopify:section:reorder', rewriteLinks);
})();
